var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCanvaLogo = function SvgCanvaLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1900,
    height: 1900,
    viewBox: "0 0 1900 1900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2952_51)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1900,
    height: 1900,
    fill: "#7D2AE7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1900,
    height: 1900,
    fill: "url(#paint0_radial_2952_51)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1900,
    height: 1900,
    fill: "url(#paint1_radial_2952_51)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1900,
    height: 1900,
    fill: "url(#paint2_radial_2952_51)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1900,
    height: 1900,
    fill: "url(#paint3_radial_2952_51)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.4,36.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1706.42 1001.64C1703.85 1001.64 1701.28 1003.56 1700.64 1006.77C1685.25 1050.39 1664.72 1076.7 1647.4 1076.7C1637.77 1076.7 1633.93 1065.79 1633.93 1048.47C1633.93 1005.49 1659.59 914.393 1672.42 872.694C1673.7 867.562 1674.98 863.071 1674.98 859.222C1674.98 847.033 1668.57 841.26 1651.89 841.26C1634.57 841.26 1615.32 848.316 1596.72 880.392C1590.3 852.165 1571.06 839.335 1544.11 839.335C1512.68 839.335 1483.17 859.222 1458.15 891.94C1433.13 925.299 1404.26 934.921 1382.45 929.789C1398.49 891.298 1404.26 862.43 1404.26 841.26C1404.26 807.901 1387.58 787.372 1361.28 787.372C1320.86 787.372 1297.13 826.505 1297.13 866.92C1297.13 898.355 1311.24 931.072 1342.68 946.469C1316.37 1006.13 1277.88 1060.02 1263.13 1060.02C1244.52 1060.02 1238.75 967.639 1240.03 901.562C1240.67 863.713 1243.88 861.788 1243.88 850.241C1243.88 843.826 1239.39 839.335 1222.71 839.335C1182.94 839.335 1170.11 873.336 1168.18 911.827C1167.54 926.582 1165.62 941.337 1161.13 955.45C1144.45 1015.11 1109.8 1060.66 1087.35 1060.66C1077.09 1060.66 1073.88 1050.39 1073.88 1036.28C1073.88 993.3 1097.62 939.412 1097.62 893.864C1097.62 859.864 1082.86 838.694 1055.28 838.694C1022.56 838.694 978.934 877.826 937.877 950.959C951.349 895.147 957.123 840.618 916.707 840.618C909.65 840.618 900.669 842.543 891.688 847.033C886.556 849.599 883.348 854.732 883.348 860.505C887.197 920.166 835.234 1072.85 786.479 1072.85C777.497 1072.85 773.007 1063.23 773.007 1047.83C773.007 1004.85 798.668 913.751 811.498 872.053C813.423 866.92 814.064 861.788 814.064 857.939C814.064 846.392 807.007 840.618 790.969 840.618C773.648 840.618 754.403 847.033 735.799 879.751C729.384 851.524 710.138 838.694 683.194 838.694C638.929 838.694 589.533 885.524 567.721 946.469C538.853 1027.94 480.474 1106.21 401.568 1106.21C330.359 1106.21 292.509 1046.55 292.509 952.884C292.509 816.882 391.945 706.541 465.719 706.541C501.003 706.541 517.682 728.994 517.682 763.636C517.682 805.335 494.588 824.58 494.588 840.618C494.588 845.75 498.437 850.241 506.777 850.241C538.853 850.241 576.702 812.391 576.702 761.07C576.702 709.748 535.003 671.899 461.229 671.899C339.982 673.182 217.452 796.353 217.452 953.525C217.452 1078.62 279.037 1154.32 386.171 1154.32C459.304 1154.32 522.815 1097.87 556.815 1031.79C560.664 1086.96 585.683 1115.19 623.533 1115.19C657.534 1115.19 684.477 1095.3 705.647 1060.02C713.987 1097.23 735.157 1115.19 762.743 1115.19C794.177 1115.19 821.121 1095.3 846.14 1057.45C845.499 1086.96 852.555 1114.55 877.574 1114.55C889.763 1114.55 903.877 1111.98 906.443 1101.07C933.387 990.734 999.463 900.279 1019.35 900.279C1025.12 900.279 1027.05 906.053 1027.05 913.11C1027.05 943.261 1005.88 1004.85 1005.88 1043.98C1005.88 1086.32 1023.84 1114.55 1061.05 1114.55C1102.75 1114.55 1144.45 1063.87 1172.67 990.092C1181.65 1059.38 1200.26 1115.19 1230.41 1115.19C1266.98 1115.19 1331.77 1038.21 1370.9 957.375C1386.3 959.299 1409.39 958.658 1431.21 943.261C1421.58 966.997 1416.45 993.3 1416.45 1019.6C1416.45 1095.3 1452.38 1115.83 1483.17 1115.83C1517.17 1115.83 1544.11 1095.94 1565.28 1060.66C1572.34 1092.73 1589.66 1115.83 1622.38 1115.83C1673.06 1115.83 1717.32 1063.87 1717.32 1021.53C1717.32 1008.7 1712.19 1001.64 1706.42 1001.64ZM654.326 1072.85C633.797 1072.85 626.099 1052.32 626.099 1021.53C626.099 968.28 662.666 879.109 701.157 879.109C717.836 879.109 724.251 898.996 724.251 923.374C724.251 977.262 689.609 1072.85 654.326 1072.85ZM1355.51 913.751C1343.32 898.996 1338.83 879.109 1338.83 861.788C1338.83 839.977 1346.52 821.373 1356.15 821.373C1365.13 821.373 1368.34 830.995 1368.34 843.826C1368.98 865.637 1361.28 897.713 1355.51 913.751ZM1514.6 1072.85C1494.07 1072.85 1486.38 1049.11 1486.38 1021.53C1486.38 970.205 1522.94 879.109 1562.07 879.109C1578.75 879.109 1585.17 898.996 1585.17 923.374C1584.53 977.262 1550.53 1072.85 1514.6 1072.85Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2952_51",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367 1684) rotate(-49.4156) scale(1469.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2952_51",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(503 216) rotate(54.7035) scale(1657.12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2952_51",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367 1684) rotate(-45.1954) scale(1451.7 667.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2952_51",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(777 256) rotate(66.5198) scale(1495.86 2505.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.725916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2952_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1900,
    height: 1900,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCanvaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "canva-logo.93703c6c9e87e88a2b444a938d7ac6b8.svg";